module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Roggenburg_BL-da95d3121a42be08b50e659dfbb9cad8.png";